
import { useCallback, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as FormActions from "../redux/actions/FormAction"

import { useDialogService } from './useDialogService';

import { Severity } from '../constants/ProConstants';
import _ from 'lodash'


const useFormServices = ()=>{

    const {actions:{ShowDialog}} = useDialogService();
   

    const closeForm = useSelector((state)=>{
        return state.form.closeForm;
    })
  
    const isDirty = useSelector((state)=>{
        return state.form.isDirty
    })

   useEffect(()=>{
       console.log("FORMIK", isDirty)

   }, [isDirty])

    const ConfirmFormAction = async (action = null)=>{   
                  
            if(isDirty)  {  
                var header =   `Unsaved Changes`
                var body = "You have unsaved changes. How would you like to continue?" 
                var labelOk = "Continue Editing";
                var labelCancel = "Discard Changes";                        
                await ShowDialog(header, body, null, labelOk, labelCancel, Severity.Info,
                    async ()=>{   
                        console.log("Continue Editing");
                                           
                    },
                    ()=>{
                        console.log("Cancelled");
                        closeForm && closeForm(false);
                        action && action()                        
                    })   
            }
            else {
                closeForm && closeForm(false);
            }            
        
      
    }
     
    const dispatchForm = useDispatch();

    const Initialize = useCallback((closeForm)=>{
        const action = FormActions.Initialize(closeForm);
        dispatchForm(action);

    }, [dispatchForm])

    const UpdateFormState = useCallback((isDirty)=>{
        const action = FormActions.UpdateFormState(isDirty);
        dispatchForm(action);

    }, [dispatchForm])

    return {data:{isDirty}, actions:{ConfirmFormAction, Initialize, UpdateFormState}}


}

export default useFormServices